import { Component, Renderer2 } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from 'src/app/private/shared/component/sidebar/sidebar.component';
import { HeaderComponent } from "../../shared/component/header/header.component";
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { GlobalToastComponent } from "../../../../global-toast.component";
import { LayoutService } from 'src/app/layout/service/layout.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { AppFloatingConfigurator } from "src/app/layout/component/app.floatingconfigurator";

@Component({
  selector: 'app-main',
  imports: [RouterModule, SidebarComponent, HeaderComponent, GlobalToastComponent, CommonModule, AppFloatingConfigurator],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
  sidebarWidth = 60
  isInitialized$: Observable<boolean>;
  modules: any = [];
  permissions: any = [];

  private scriptElement: HTMLScriptElement | null = null;


  constructor(private layoutService: LayoutService,
    private renderer: Renderer2,
    private localStorage: LocalStorageService
  ) {
    this.isInitialized$ = this.layoutService.initialized$
  }

  ngOnInit() {
    console.log("modules", this.localStorage.getFeatureModules())
    this.modules = JSON.parse(this.localStorage.getFeatureModules() || '[]');
    this.permissions = JSON.parse(this.localStorage.getPermissions() || '[]');
    console.log("permissions", this.permissions)
   
  }

 

  onSidebarWidthChange(width: any) {
    this.sidebarWidth = width
  }

  getFeatureModuleAccess(module_name: any) {
    console.log(this.modules)
    console.log(this.modules.includes(module_name))
    return (this.modules.includes(module_name) ? true : false);
  }

  getAccess(module_name: any) {
    console.log("pemision",this.permissions)
    let result = this.permissions.filter((item: any) => {
      return item.module_name == module_name && item.active == true;
    })
    console.log("gaurav", result[0])
    return (result[0]) ? true : false;
    //return true;
  }

}
